export default HTTPClient => ({
  search: async (request = {
    page: 0, perPage: 2, catalogs: {}, filters: {}, years: [], raw: '',
  }) => {
    const page = request.page || 0;
    const perPage = request.perPage || 10;
    const catalogs = request.catalogs || {};
    const filters = request.filters || {};
    const years = request.years || [];
    const raw = isNaN(request.raw) ? '' : request.raw; // eslint-disable-line

    const resp = await HTTPClient.post('exams/search', {
      body: JSON.stringify({
        limit: perPage,
        offset: perPage * page,
        catalogs,
        filters,
        years,
        raw,
      }),
    });
    return resp;
  },
  readOne: async (id) => {
    const resp = await HTTPClient.get(`exams/${id}`);
    return resp;
  },
  create: async (exam) => {
    const resp = await HTTPClient.post('exams/', {
      body: JSON.stringify(exam),
    });
    return resp;
  },
  update: async (id, exam) => {
    const resp = await HTTPClient.put(`exams/${id}`, {
      body: JSON.stringify(exam),
    });
    return resp;
  },
});
